import React, { useEffect, useState } from "react";
import axios from "axios";
import { useStyletron } from "baseui";
import { Pagination } from "baseui/pagination";
import Loading from "../../tools/loading.js";
import { Grid, Cell } from "baseui/layout-grid";

import {
  StatefulDataTable,
  StringColumn,
  CustomColumn,
} from "baseui/data-table";
import { Show } from "baseui/icon";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalButton,
} from "baseui/modal";

function Chats() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [css] = useStyletron();
  const [data, setData] = useState([]);
  const [uniqueConversations, setUniqueConversations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const limit = 20;
  const [isOpen, setIsOpen] = useState(false);
  const [selectedConversation, setSelectedConversation] = useState(null);

  const handleViewConversation = (conversationId) => {
    const conversation = data.filter(
      (item) => item.conversation_id === conversationId
    );
    setSelectedConversation(conversation);
    setIsOpen(true);
  };

  const columns = [
    CustomColumn({
      title: "View",
      sortable: false,
      mapDataToValue: (data) => data,
      renderCell: (props) => {
        const rowData = props.value;
        return (
          <div>
            <Show
              style={{ color: "green" }}
              size={30}
              onClick={() => handleViewConversation(rowData.conversation_id)}
            >
              View
            </Show>
          </div>
        );
      },
    }),
    StringColumn({
      title: "Conversation ID",
      mapDataToValue: (data) => data.conversation_id,
    }),
    StringColumn({
      title: "Interaction Count",
      mapDataToValue: (data) => data.interaction_count.toString(),
    }),
    StringColumn({
      title: "Most Recent Date (UTC-5)",
      mapDataToValue: (data) =>
        new Date(data.most_recent_date).toLocaleString("en-US", {
          timeZone: "America/New_York",
        }), // Adjust to UTC-5
    }),
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/admin/chats`);
        const conversationMap = response.data.reduce((acc, item) => {
          if (!acc[item.conversation_id]) {
            acc[item.conversation_id] = {
              conversation_id: item.conversation_id,
              interaction_count: 0,
              most_recent_date: new Date(0), // Initialize with the earliest possible date
            };
          }
          acc[item.conversation_id].interaction_count += 1;
          const itemDate = new Date(item.timestamp);
          if (itemDate > acc[item.conversation_id].most_recent_date) {
            acc[item.conversation_id].most_recent_date = itemDate;
          }
          return acc;
        }, {});

        const uniqueConversations = Object.values(conversationMap);
        setData(response.data);
        setUniqueConversations(uniqueConversations);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [apiUrl]);

  const numPages = Math.ceil(uniqueConversations.length / limit);
  const rows = uniqueConversations
    .slice((currentPage - 1) * limit, currentPage * limit)
    .map((item, index) => ({
      id: (currentPage - 1) * limit + index,
      data: item,
    }));

  if (isLoading) {
    return <Loading />;
  }

  const handlePageChange = ({ nextPage }) => {
    setCurrentPage(Math.min(Math.max(nextPage, 1), numPages));
  };

  return (
    <div className={css({ height: "100vh" })}>
      <Grid>
        <Cell span={12}>
          <div
            className={css({
              height: "75vh",
              display: "flex",
              flexDirection: "column",
            })}
          >
            <StatefulDataTable
              columns={columns}
              rows={rows}
              overrides={{
                Root: {
                  style: {
                    height: "calc(100% - 50px)",
                  },
                },
              }}
            />
            <Pagination
              numPages={numPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
              overrides={{
                Root: {
                  style: {
                    height: "50px",
                  },
                },
              }}
            />
          </div>
        </Cell>
      </Grid>
      <Modal
        onClose={() => setIsOpen(false)}
        isOpen={isOpen}
        closeable
        animate
        autoFocus
        overrides={{
          Dialog: {
            style: {
              width: "80vw",
              height: "80vh",
              display: "flex",
              flexDirection: "column",
            },
          },
        }}
      >
        <ModalHeader>Conversation Details</ModalHeader>
        <ModalBody>
          {selectedConversation &&
            selectedConversation.map((msg) => (
              <div key={msg.id}>
                <strong>{msg.sender}</strong>: {msg.message}{" "}
                <em>({new Date(msg.timestamp).toLocaleString()})</em>
                <hr />
              </div>
            ))}
        </ModalBody>
        <ModalFooter>
          <ModalButton onClick={() => setIsOpen(false)}>Close</ModalButton>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default Chats;
